import { useCallback } from "react";

import { useOtaUpdateOverlayContext } from "../context/OtaUpdateOverlayContext";

export const useSchemaVersionMismatchHandler = () => {
  const { handleSchemaVersionMismatch } = useOtaUpdateOverlayContext();

  return useCallback(() => {
    handleSchemaVersionMismatch();
  }, [handleSchemaVersionMismatch]);
};
